var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 10a8.333 8.333 0 1 0-9.635 8.232V12.41H6.582V10h2.116V8.164c0-2.088 1.244-3.242 3.147-3.242.912 0 1.866.163 1.866.163v2.05H12.66c-1.035 0-1.358.643-1.358 1.302V10h2.311l-.37 2.409h-1.941v5.823A8.335 8.335 0 0 0 18.333 10"
  })));
};
export default SvgFacebook;